export const createSearchProps = ({
  requestHandler,
  metricHandler,
  semMetricHandler,
  searchHandler
}) => {
  const {
    handleSearchLoaded,
    handleDisplayedItinerariesChange,
    handleNoSearchResults,
    handleLoadingResultsPage,
    handlerCreateMapiShoppingCart,
    handlerSearchMapiError
  } = searchHandler;
  return {
    listenSearchRequestChanges: requestHandler.onSearch,
    stopListenSearchRequestChanges: metricHandler.stopOnSearch,
    endSearchMetric: metricHandler.end,
    endSemSearchMetric: semMetricHandler.end,
    onSearchLoaded: handleSearchLoaded,
    onDisplayedItinerariesChange: handleDisplayedItinerariesChange,
    onNoSearchResults: handleNoSearchResults,
    onLoadingResultsPage: handleLoadingResultsPage,
    onCreateMapiShoppingCart: handlerCreateMapiShoppingCart,
    onSearchMapiError: handlerSearchMapiError
  };
};